import { Directive, HostListener, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[formHelpText]'
})
export class FormContromHelpTextDirective {

  constructor(private _el: ElementRef, private renderer: Renderer) { }

  @HostListener('focus', ['$event']) onFocus(event) {
    if (this._el.nativeElement.nextElementSibling.nodeName === 'I') {
      const helpText = this._el.nativeElement.nextElementSibling.innerHTML;
      const containerHelper = document.querySelector('.help-text-container p');
      containerHelper.innerHTML = helpText;

      const positioTop = document.querySelector('.container-fluid.h-100.mb-50').scrollTop;
      const top = (this._el.nativeElement.getBoundingClientRect().top - 255) + positioTop;
      this.renderer.setElementStyle(document.querySelector('.help-text-container'), 'top', top + 'px');

    }
  }
}
